import {FormControl, Validators} from "@angular/forms";

export class Openingbalances {
  id: string;
  organization_id: string;
  branch_id: string;
  action_year: string;
  sdate_time: string;
  edate_time: string;

  account_no: string;
  statement: string;
  fromDebit: string;
  toDebit: string;
  fromCredit: string;
  toCredit: string;
  document_type: string;
  document_no: string;
  cost_center_id: string;
  inv_details: string;


  last_on_behalf_of: string;
  showDeletedOnly: boolean;
  showDifferenceOnly: boolean;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/views/fin/openingbalances/openingbalances.ts